var _rect, _rect2, _rect3, _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUniverseSelection(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.20509,
    y: 0.20509,
    width: 39.5898,
    height: 39.5898,
    rx: 19.7949,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.20509,
    y: 0.20509,
    width: 39.5898,
    height: 39.5898,
    rx: 19.7949,
    stroke: "url(#paint0_linear_2432_44108)",
    strokeWidth: 0.41018
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 7.24025,
    y: 7.24037,
    width: 25.5193,
    height: 25.5193,
    rx: 12.7596,
    stroke: "url(#paint1_linear_2432_44108)",
    strokeOpacity: 0.4,
    strokeWidth: 0.41018
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.9191 16.9886C24.686 16.9886 24.4959 17.1787 24.4959 17.4118V26.0482C24.4959 26.2813 24.686 26.4714 24.9191 26.4714H26.3451C26.5782 26.4714 26.7683 26.2813 26.7683 26.0482V17.4118C26.7683 17.1787 26.5782 16.9886 26.3451 16.9886H24.9191ZM21.1704 20.4398C20.9373 20.4398 20.7473 20.6299 20.7473 20.863V26.1367C20.7473 26.3698 20.9374 26.5599 21.1704 26.5599H22.5965C22.8296 26.5599 23.0197 26.3698 23.0197 26.1367C23.0197 24.3788 23.0197 22.6209 23.0197 20.863C23.0197 20.6299 22.8296 20.4398 22.5965 20.4398C22.1211 20.4398 21.6458 20.4398 21.1704 20.4398ZM17.4218 19.2008C17.1887 19.2008 16.9986 19.3909 16.9986 19.624V26.2252C16.9986 26.4583 17.1887 26.6484 17.4218 26.6484H18.8479C19.0809 26.6484 19.271 26.4583 19.271 26.2252V19.624C19.271 19.3909 19.0809 19.2008 18.8479 19.2008H17.4218ZM13.6732 22.8434H15.0992C15.3323 22.8434 15.5224 23.0335 15.5224 23.2666V26.3136C15.5224 26.5467 15.3323 26.7368 15.0992 26.7368H13.6732C13.4401 26.7368 13.25 26.5467 13.25 26.3136V23.2666C13.25 23.0335 13.4401 22.8434 13.6732 22.8434Z",
    fill: "url(#paint2_linear_2432_44108)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3599 16.4831L14.7052 18.8065C14.575 18.738 14.4266 18.6992 14.2693 18.6992C13.7517 18.6992 13.332 19.1187 13.332 19.6364C13.332 20.1541 13.7517 20.5736 14.2692 20.5737C14.7869 20.5737 15.2065 20.1541 15.2065 19.6365C15.2065 19.5232 15.1865 19.4147 15.1497 19.3142L17.8043 16.9908C17.9346 17.0594 18.0828 17.0982 18.2402 17.0982C18.5261 17.0982 18.782 16.9702 18.9539 16.7684L21.0521 17.503C21.0678 18.0069 21.4811 18.4106 21.9888 18.4106C22.5065 18.4106 22.9261 17.991 22.9261 17.4734C22.9261 17.3642 22.9074 17.2594 22.8731 17.162L25.2919 15.0953C25.4244 15.1671 25.5762 15.2078 25.7374 15.2078C26.2551 15.2078 26.6747 14.7882 26.6747 14.2705C26.6747 13.7529 26.2551 13.3333 25.7374 13.3333C25.2198 13.3333 24.8002 13.7529 24.8002 14.2705C24.8002 14.3797 24.8189 14.4845 24.8533 14.5819L22.4344 16.6486C22.3019 16.5769 22.1501 16.5361 21.9889 16.5361C21.703 16.5361 21.4471 16.6641 21.2752 16.8659L19.177 16.1313C19.1614 15.6274 18.748 15.2237 18.2402 15.2237C17.7226 15.2237 17.303 15.6433 17.303 16.1609C17.303 16.2741 17.3231 16.3826 17.3599 16.4831Z",
    fill: "#CABCFF"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2432_44108",
    x1: 20,
    y1: 0,
    x2: 20,
    y2: 40,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9383F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAF9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2432_44108",
    x1: 19.9999,
    y1: 7.03528,
    x2: 19.9999,
    y2: 32.9648,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CAC2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9383F5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2432_44108",
    x1: 26.7683,
    y1: 21.8627,
    x2: 13.25,
    y2: 21.8627,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A631FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#896DFA"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUniverseSelection);
export default __webpack_public_path__ + "static/media/universe-selection.28689bae724d7e3a57246e83e4a6179e.svg";
export { ForwardRef as ReactComponent };